import { defineComponent as _defineComponent } from 'vue'
import CodeGroup from '@/components/codeGroup'
import MTrimSetting from '@/components/engraving/m-trim-setting.vue'
import { translate } from '@/util/commonFun'
import mMachinePos from '@/views/preLayoutSetting/components/m-machine-pos.vue'
import {
  computed,
  getCurrentInstance,
  ref,
  watch,
  withDefaults,
} from 'vue'

import { options } from './configs/oneDragTwoConfig'
import {
  ChangeFieldType,
  CodeOptionsType,
  OneDrawTowType,
} from './types/oneDragTowType'

type prototypeNameType = {
  TRIM_SIDE: string
  TRIM_L_SINGLE: string
  TRIM_L_MOMENT: string
  SECOND_TRIM_VALUE: string
  NEW_TRIM: string
  TRIM: string
  SINGLE_PANEL_TRIM_DIRECTION: string
  IS_FIRST_TRIM_SINGLE_PANEL: string
  IS_DOUBLE_PANEL_FOUR_TRIM: string // 双面板修边 默认修两边
  DOUBLE_PANEL_TRIM_SHORT: string // 双面板只修短边 默认关闭
  IS_SINGLE_PANEL_FOUR_TRIM: string // 单面板修边
  // 修边补偿
  TRIM_COMPENSATION: string | number
  // 不生成路径设置
  IS_ZERO_NO_ROUTE: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'oneDragTwoEngraving',
  props: {
    obj: { default: () => ({} as any) },
    isShowSecondaryCatalog: { type: Boolean, default: false }
  },
  setup(__props: any, { expose }) {

const props = __props as { obj: OneDrawTowType, isShowSecondaryCatalog: boolean }

const that = getCurrentInstance()?.proxy as any


const showConfig = computed(() => {
  return that?.$store.getters['equipEnvironment/showConfig']
})

// let isOnTrim = ref(false)
const propertyName: prototypeNameType = {
  TRIM_SIDE: 'one_for_two_trim_side',
  TRIM_L_SINGLE: 'one_for_two_trim_single',
  TRIM_L_MOMENT: 'one_for_two_trim_moment',
  SECOND_TRIM_VALUE: 'one_for_two_second_trim_value',
  NEW_TRIM: 'one_for_two_new_trim',
  TRIM: 'one_for_two_trim',
  SINGLE_PANEL_TRIM_DIRECTION: 'one_for_two_single_panel_trim_direction',
  IS_FIRST_TRIM_SINGLE_PANEL: 'one_for_two_single_panel_trim',
  IS_DOUBLE_PANEL_FOUR_TRIM: 'one_for_two_is_double_panel_four_trim', // 双面板修边 默认修两边
  DOUBLE_PANEL_TRIM_SHORT: 'one_for_two_double_panel_trim_short', // 双面板只修短边 默认关闭
  IS_SINGLE_PANEL_FOUR_TRIM: 'one_for_two_is_single_panel_four_trim', // 单面板修边
  // 修边补偿
  TRIM_COMPENSATION: 'one_for_two_trim_compensation',
  // 不生成路径设置
  IS_ZERO_NO_ROUTE: 'one_for_two_is_zero_no_route',
}
const formData = ref<OneDrawTowType>({
  enableOneForTwoDevice: false, // 是否启用一拖二雕刻机
  oneForTwoMachineName: 'sudiao', // 一拖二雕刻机名称
  enable_one_for_two_start_position: false, // 是否启用一拖二工位起始点
  one_for_two_start_position: '左上角', // 一拖二工位起始点
  one_for_two_trimming_setting: {
    one_for_two_trim_side: 'topLeft',
    one_for_two_trim_single: false, // 只修长边
    one_for_two_trim_moment: '切割开始', // 反面修边顺序
    one_for_two_second_trim_value: 0, // 正面再修边
    one_for_two_new_trim: false, //是否开启新版修边
    one_for_two_trim: false, //修边设置是否开启
    one_for_two_is_double_panel_four_trim: false, // 双面板修边 默认修两边
    one_for_two_double_panel_trim_short: false, // 双面板只修短边 默认关闭
    one_for_two_is_single_panel_four_trim: false, // 单面板修边
    one_for_two_single_panel_trim_direction: false, // 单面板修边方向
    one_for_two_trim_compensation: 0,
    one_for_two_is_zero_no_route: false,
  }, //修边设置
  secondAutoSendStockCode: '', // 自动上下料代码
  secondPauseCode: '', // 暂停代码
  secondOddBeginCode: '', // 工位1开始代码
  secondEvenBeginCode: '', // 工位2开始代码
  secondBeginCodeF: '', // 正面开始代码
  secondBeginCodeB: '', // 反面开始代码
  secondEndCodeF: '', // 正面结束代码
  secondEndCodeB: '', // 反面结束代码
  secondRollCode: '', // 工位1翻面代码
  secondEvenRollCode: '', // 工位2翻面代码
  secondOddEndCode: '', // 工位1结束代码
  secondEvenEndCode: '', // 工位2结束代码
})
// 文件列表
const oneDragTwoOption = ref([
  { value: 'sudiao', label: 'cuttingDock.oneDragTwo.engravingPlus' },
])

const positionDis = ref([
  { position: '左下角', value: '+x,+y' },
  { position: '左上角', value: '+x,- y' },
  { position: '右下角', value: '- x,+y' },
  { position: '右上角', value: '- x,- y' },
])

const positionDisValue = computed(() => {
  return positionDis.value.filter(
    (dis) => dis.position == formData.value.one_for_two_start_position
  )[0]?.value
})

const codeOptions = ref<CodeOptionsType>(JSON.parse(JSON.stringify(options)))
const startPositionList = ref(['左上角', '右上角', '左下角', '右下角']) // 记录工位起始点可选项
const startPositionListMap = ref([
  'cuttingDock.cuttingParams.topLeftD',
  'cuttingDock.cuttingParams.topRightD',
  'cuttingDock.cuttingParams.bottomLeftD',
  'cuttingDock.cuttingParams.bottomRightD',
]) // 记录工位起始点可选项
// 更新值
function dealOptionsConfig() {
  codeOptions.value.forEach((option) => {
    option.code.forEach((it: any) => {
      it.data = formData.value[it.field as ChangeFieldType]
    })
  })
}

// 更新数据
function changeFormData(field: ChangeFieldType, value: string) {
  formData.value[field] = value
}

const onUpdateTrimSetting = (val: Array<any>) => {
  formData.value.one_for_two_trimming_setting = JSON.parse(JSON.stringify(val))
}

function handleStartPosition(item: string) {
  if (!formData.value.enable_one_for_two_start_position) return
  formData.value.one_for_two_start_position = item
}

watch(
  () => props.obj,
  () => {
    formData.value = JSON.parse(JSON.stringify(props.obj))
    dealOptionsConfig()
  }
)
// 向外部暴露
expose({
  formData,
  // isOnTrim,
})

const translateLang = (key: string) => {
  return translate(key)
}

return { __sfc: true,that, props, showConfig, propertyName, formData, oneDragTwoOption, positionDis, positionDisValue, codeOptions, startPositionList, startPositionListMap, dealOptionsConfig, changeFormData, onUpdateTrimSetting, handleStartPosition, translateLang, CodeGroup, MTrimSetting, mMachinePos }
}

})